import { isFocusable } from './tabbable.esm.js';

var focusableElements = ['a[href]', 'area[href]', 'button:not([disabled])', 'embed', 'iframe', 'input:not([disabled])', 'object', 'select:not([disabled])', 'textarea:not([disabled])', '*[tabindex]:not([aria-disabled])', '*[contenteditable]'];
var focusableElSelector = /*#__PURE__*/focusableElements.join();
function getFocusables(element, keyboardOnly) {
  if (keyboardOnly === void 0) {
    keyboardOnly = false;
  }

  if (element === null) {
    return [];
  }

  var elements = Array.from(element.querySelectorAll(focusableElSelector)); // Filter out elements with display: none

  elements = elements.filter(function (focusableEl) {
    return window.getComputedStyle(focusableEl).display !== 'none';
  });

  if (keyboardOnly === true) {
    elements = elements.filter(function (focusableEl) {
      return focusableEl.getAttribute('tabindex') !== '-1';
    });
  }

  return elements;
}
function getAllFocusable(container) {
  var focusableEls = Array.from(container.querySelectorAll(focusableElSelector));
  focusableEls.unshift(container);
  return focusableEls.filter(isFocusable).filter(function (el) {
    return window.getComputedStyle(el).display !== 'none';
  });
}

export { getAllFocusable, getFocusables };
//# sourceMappingURL=dom-query.esm.js.map
